import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ProjectFeeDetailsWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .project-details-container {
    padding: 24px 16px;
    ${responsive.MOBILE`
      padding: 16px 8px;
    `}
  }
`;
